import { useEffect } from 'react';

import { armAlertSounds, unlockAlertSounds } from '../alerts.js';
import { useSettings } from '../settings.js';
import styles from './SettingsMenu.module.css';

/** Display preferences that only affect this browser. */
export function SettingsMenu() {
  const [settings, set] = useSettings();

  useEffect(() => {
    if (!settings.alertSounds) return;
    return armAlertSounds();
  }, [settings.alertSounds]);

  return (
    <div className={styles.menu}>
      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={settings.cardPatterns}
          onChange={(e) => set('cardPatterns', e.target.checked)}
        />
        <span>Card patterns</span>
      </label>
      <div className={styles.soundSetting}>
        <label
          className={styles.toggle}
          title="Chime when your turn starts or the game needs your attention"
        >
          <input
            type="checkbox"
            checked={settings.alertSounds}
            onChange={(e) => {
              if (e.target.checked) unlockAlertSounds();
              set('alertSounds', e.target.checked);
            }}
          />
          <span>Alert sounds</span>
        </label>
        {settings.alertSounds && (
          <label className={styles.volume}>
            <span>Volume</span>
            <input
              type="range"
              min="0"
              max="100"
              step="5"
              value={settings.alertVolume}
              onChange={(e) => set('alertVolume', e.target.valueAsNumber)}
            />
            <output>{settings.alertVolume}%</output>
          </label>
        )}
      </div>
    </div>
  );
}
